import PreviousOrNextButton from "components/common/controls/PreviousOrNextButton";
import Select from "components/common/controls/Select";
import moment, { Moment } from "moment";
import { Component } from "react";
import { ControlSize } from "shared/enums/ControlSizeEnum";
import { GetEnumKeys } from "shared/utility/CommonUtility";
import {
  checkIfDateIsAfterToday,
  checkIfDateIsFromCurrentMonth,
  checkIfDateIsFromCurrentYear,
  getMonthsStartAndEndDate,
  getYearsStartAndEndDate,
} from "shared/utility/DateTimeUtility";
import { ChartGranularity } from "shared/enums/ChartGranularityEnum";
import "./styles/SummaryChartGranularitySelect.css";

interface Props {
  onChange: (mode: string) => void;
  onFilterDateChange: (fromDate: Moment, toDate: Moment) => void;
  viewMode: ChartGranularity;
  fromDate: Moment;
  toDate: Moment;
}

export default class SummaryChartGranularitySelect extends Component<
  Props,
  any
> {
  handleSelectionChange = ({ selectedItem }: any) => {
    this.props.onChange(selectedItem);
  };

  adjustToDateIfRequired = (toDate: Moment) => {
    // toDate can not be after today's date.
    if (checkIfDateIsAfterToday(toDate)) {
      toDate.set(moment().toObject());
    }
  };

  handlePreviousClick = () => {
    let newFromDate, newToDate;
    if (this.props.viewMode === ChartGranularity.Monthly) {
      [newFromDate, newToDate] = getMonthsStartAndEndDate(
        this.props.fromDate.clone().subtract(1, "days")
      );
    } else {
      [newFromDate, newToDate] = getYearsStartAndEndDate(
        this.props.fromDate.clone().subtract(1, "days")
      );
    }
    this.props.onFilterDateChange(newFromDate, newToDate);
  };

  handleNextClick = () => {
    let newFromDate, newToDate;
    if (this.props.viewMode === ChartGranularity.Monthly) {
      [newFromDate, newToDate] = getMonthsStartAndEndDate(
        this.props.toDate.clone().add(1, "days")
      );
    } else {
      [newFromDate, newToDate] = getYearsStartAndEndDate(
        this.props.toDate.clone().add(1, "days")
      );
    }
    this.adjustToDateIfRequired(newToDate);
    this.props.onFilterDateChange(newFromDate, newToDate);
  };

  checkIfNextButtonShouldDisabled = () => {
    if (this.props.viewMode === ChartGranularity.Yearly) {
      return (
        checkIfDateIsFromCurrentYear(this.props.fromDate) ||
        checkIfDateIsFromCurrentYear(this.props.toDate)
      );
    }

    return (
      checkIfDateIsFromCurrentMonth(this.props.fromDate) ||
      checkIfDateIsFromCurrentMonth(this.props.toDate)
    );
  };

  render() {
    return (
      <>
        <div className="flex">
          <div className="mr-2 md:mr-0">
            <PreviousOrNextButton
              variant="previous"
              onClick={this.handlePreviousClick}
            />
          </div>
          <div className="hidden md:block">
            <Select
              dataSource={GetEnumKeys(ChartGranularity)}
              width="80px"
              radiusSize={ControlSize.Midium}
              className="summary-chart-select border-promGray2 mx-1"
              onSelectionChanged={this.handleSelectionChange}
              defaultValue={this.props.viewMode}
            />
          </div>
          <PreviousOrNextButton
            variant="next"
            onClick={this.handleNextClick}
            isDisabled={this.checkIfNextButtonShouldDisabled()}
          />
        </div>
      </>
    );
  }
}
